<template>
    <div
        class="wrapper-finish"
        :style="{
            backgroundImage: bgUrl ? 'url(' + bgUrl + ')' : '',
            backgroundRepeat: bgUrl ? 'no-repeat' : 'repeat-x',
            backgroundSize: bgUrl ? '10rem' : ''
        }"
    >
        <LoginForm ref="loginform" @on-success="handleLoginSuccess"></LoginForm>
        <div v-show="!isShowLogin">
            <!-- <img class="bg-icons" :src="bgUrl || bgIcon" alt="" /> -->
            <Title></Title>
            <div class="finish">
                <img src="@/assets/images/finish.png" class="icon-finish" />
                <div class="text-finish">
                    {{ submitText }}
                </div>
            </div>
            <Draw ref="drawref" @on-need-login="hanldeStartLogin" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getLoginInfo, performNativeLogin } from '@eastmoney/mku';
import { setAuthCookies } from '@/libs/auth-cookie';
import { CHANGE_QUESTIONNAIRE_CODE } from '@/libs/constant';
import { RewardFlag } from '@/libs/enum';
import browser from '@/libs/browser';
import Title from './components/Title';
import Draw from './components/draw';
import LoginForm from './components/LoginForm';
import bgIcon from '@/assets/images/bg-icons.png';

export default {
    name: 'QuestionEnd',
    components: {
        Title,
        Draw,
        LoginForm
    },
    computed: {
        ...mapState(['submitText', 'questionnaireCode', 'pictureConfig']),
        isHaveReward() {
            return (
                this.$store.state.rewardConfig &&
                this.$store.state.rewardConfig.rewardFlag === RewardFlag.yes
            );
        },
        bgUrl() {
            return this.pictureConfig.h5Bg;
        }
    },
    data() {
        return {
            isShowLogin: false,
            bgIcon
        };
    },
    methods: {
        jumpToConfigUrl() {
            if (this.isHaveReward) {
                return;
            }
            const { submitUrl } = this.$store.state;
            if (submitUrl) {
                setTimeout(() => {
                    window.location.href = submitUrl;
                }, 1000);
            }
        },
        handleToDraw() {
            this.isShowLogin = false;
            this.$refs.drawref.handleToReward();
        },
        async handleLoginSuccess() {
            const { code } = this.$route.query;
            if (code) {
                this.handleToDraw();
            } else {
                this.$toast('当前页面地址不存在问卷代码');
            }
        },
        hanldeStartLogin() {
            // 需要登录
            if (browser.isApp()) {
                this.handleAppLogin();
            } else {
                this.isShowLogin = true;
                this.$refs.loginform.show();
            }
        },
        handleAppLogin() {
            getLoginInfo(
                res => {
                    const { ct, ut } = res.data;
                    setAuthCookies({ ct, ut });
                    this.handleToDraw();
                },
                () => {
                    performNativeLogin(
                        res => {
                            const { ct, ut } = res.data;
                            setAuthCookies({ ct, ut });
                            this.handleToDraw();
                        },
                        () => {
                            console.log('登录失败');
                        }
                    );
                }
            );
        }
    },
    mounted() {
        if (!this.questionnaireCode) {
            const { code } = this.$route.query;
            this.$store.commit(CHANGE_QUESTIONNAIRE_CODE, code);
            this.$store.dispatch('getQuestionConfig', code);
        } else {
            this.jumpToConfigUrl();
        }
    }
};
</script>

<style scoped lang="scss">
.wrapper-finish {
    // background-image: linear-gradient(180deg, #f87a3b 0%, #f97c3c 66%, #ffffff 100%);
    width: 750px;
    background-image: url('../assets/images/bg-jianbian.png');
    background-repeat: repeat-x;
    background-size: 100% 720px;
    background-attachment: fixed;
    overflow: hidden;
    position: relative;
    margin: 0 auto;
    background-color: #fff;
    .bg-icons {
        position: absolute;
        top: 0;
        left: 0;
        width: 750px;
    }
}
.finish {
    position: relative;
    margin: 32px 32px;
    background-color: #fff;
    border-radius: 12px;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    min-height: calc(100vh-32px);
    padding-top: 300px;
    .icon-finish {
        width: 160px;
        height: 160px;
    }
    .text-finish {
        padding: 0 10px;
        color: grey;
        font-size: 30px;
        margin-top: 20px;
        text-align: center;
        word-break: break-all;
    }
}
</style>
